/* NANEND_IMG_DECODING_V1 — 2026-10-18
   首页滚动卡顿 #2：全站图片解码改为 async，避免图片解码和滚动抢主线程。
   规则：
   1) 首屏内（视口内）与 fetchpriority=high 的图片**跳过**，不干扰 LCP；
   2) 其余图片设置 decoding=async；
   3) 用 MutationObserver 兜住运行时插入的图片（Swiper 克隆、抽屉、快捷搜索等），8 秒后自动断开。
   回滚：删除 theme.liquid 中引用本文件的 <script> 即可（本文件可留着不加载）。 */
(function () {
  var SKIP = 'img[fetchpriority="high"]';
  function apply(root) {
    if (!root.querySelectorAll) return;
    var imgs = root.querySelectorAll('img');
    var vh = window.innerHeight || 800;
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.getAttribute('decoding') === 'async') continue;
      if (img.matches && img.matches(SKIP)) continue;
      var r = img.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) continue; // 首屏内，交给浏览器默认
      img.decoding = 'async';
    }
  }
  function start() {
    apply(document);
    if (!window.MutationObserver) return;
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.tagName === 'IMG') { if (!n.getAttribute('decoding')) n.decoding = 'async'; }
          else apply(n);
        }
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 8000);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
